module.exports = __webpack_public_path__ + "img/couples-084.a7b8369a.jpg";